"use strict";
/**
 * Registry Whitelists — sl-ngy4.10.
 *
 * Build-time whitelists for user-authored NodeTypeDefinitions published
 * via the marketplace (L2.10). These values travel with a published
 * step-template zip and MUST be known to both frontend (editor widget)
 * and backend (validation service).
 *
 * The corresponding runtime registries live in the frontend
 * (`WIDGET_REGISTRY`, `PANEL_BANNER_REGISTRY`, `PANEL_HOOK_REGISTRY`,
 * `DATA_SOURCE_REGISTRY`). A registered runtime entry NOT listed here is
 * a build error waiting to happen — the node type editor will refuse to
 * select it and the validation service will reject it at publish time.
 *
 * Any addition here MUST be paired with a corresponding registry entry
 * on the frontend side. If a runtime entry is removed, delete the ID
 * here in the same PR.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTHORABLE_STEP_TYPES = exports.AUTHORABLE_NODE_CATEGORIES = exports.PANEL_HOOK_KINDS = exports.PANEL_BANNER_KINDS = exports.DATA_SOURCE_IDS = exports.WIDGET_IDS = void 0;
/**
 * Widget primitive IDs registered in `WIDGET_REGISTRY` (frontend
 * `workflow-viewer/widgets/index.ts`). Consumed by:
 *   - Admin NodeTypeEditor (slot.widget dropdown)
 *   - ServiceNodeValidationService (rule 3)
 */
exports.WIDGET_IDS = [
    'input-text',
    'input-number',
    'boolean-switch',
    'enum-select',
    'dynamic-select',
    'template-input',
    'template-editor',
    'code-editor',
    'json-editor',
    'json-extract-fields',
    'attachment-picker',
    'field-list-editor',
    'port-editor',
];
/**
 * Dynamic data source IDs registered in `DATA_SOURCE_REGISTRY` (frontend
 * `workflow-viewer/data-sources/`). Used when a slot has
 * `widget: 'dynamic-select'` + `optionsSource: '<id>'`.
 */
exports.DATA_SOURCE_IDS = [
    'aiRegistry.providers',
    'aiRegistry.models',
    'streamlain.managedPolicies',
    'workspace.credentials',
    'workspace.plan',
];
/**
 * Panel banner kinds registered in `PANEL_BANNER_REGISTRY` (frontend
 * `workflow-viewer/panel-primitives.ts`). Emitted via `panelBanners[]`
 * on a NodeTypeDefinition.
 */
exports.PANEL_BANNER_KINDS = ['plan-hint-banner'];
/**
 * Panel hook kinds registered in `PANEL_HOOK_REGISTRY` (frontend
 * `workflow-viewer/panel-primitives.ts`). Emitted via `panelHooks[]`
 * on a NodeTypeDefinition.
 */
exports.PANEL_HOOK_KINDS = ['ai-credential-warning'];
/**
 * Admin-editable NodeCategory values for user-authored templates.
 * Mirrors the frontend `NodeCategory` union (graph-core-types.ts) — kept
 * in sync via explicit enumeration because the enum lives in the frontend
 * package and cannot be imported here without introducing a cycle.
 *
 * NOTE: `interface` is excluded because Start/End nodes are structural
 * boundaries of the workflow itself and cannot be authored.
 */
exports.AUTHORABLE_NODE_CATEGORIES = [
    'ai',
    'code',
    'http',
    'service',
    'media',
    'control',
];
/**
 * Step-type runtimes an admin may choose for user-authored nodes.
 * Mirrors `ADMIN_EDITABLE_SERVICE_NODE_STEP_TYPES` in the backend
 * admin controller. Kept here so the admin frontend can validate without
 * a network round-trip.
 */
exports.AUTHORABLE_STEP_TYPES = ['http', 'code', 'media'];
